import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { apiRequest, incaAccessor } from '@cancercentrum/inca';
import { useState } from 'react';
import Select from 'react-select';
import { Alert, Button, Col, ControlLabel, FormControl, FormGroup, Modal, Row } from '@cancercentrum/rcc-bootstrap';
import { faSave, faTimes } from '@fortawesome/free-solid-svg-icons';
import VanillaQuestion from '../../../Question/Vanilla';
import { useErrandPanelContext } from '../../ErrandPanel';
import { ReviewerSection } from '../../../ReviewerSection';
import { ReporterSection } from '../../../ReporterSection';
export const ErrandInformationModal = (props)=>{
    const { onCancel, onSuccess } = props;
    const ctx = useErrandPanelContext();
    const priorities = [
        {
            key: null,
            name: 'Normal'
        },
        {
            key: 'Brådskande',
            name: 'Brådskande'
        }
    ];
    const [saveError, setSaveError] = useState('');
    const [comment, setComment] = useState(ctx.errandComment);
    const [reviewerComment, setReviewerComment] = useState(ctx.errand.reviewerComment ?? '');
    const [date, setDate] = useState(ctx.errand.followUpComment ?? '');
    const [reviewerId, setReviewerId] = useState(ctx.errand.reviewerId);
    const [priority, setPriority] = useState(ctx.errand.priority);
    const [reviewerName, setReviewerName] = useState(ctx.errand.reviewerName);
    const [reporterId, setReporterId] = useState(ctx.errand.reporterId);
    const [reporterName, setReporterName] = useState(ctx.errand.reporterName);
    const fakeRegvarMetadata = {
        dataType: 'datetime',
        label: 'Bevakningsdatum för inrapportering',
        description: '',
        includeTime: false,
        compareDescription: '',
        isComparable: false,
        serversideOnly: false,
        sortOrder: 0,
        technicalName: ''
    };
    const handleDateChange = (d)=>{
        setDate(d);
    };
    const handleReviewerChange = (user)=>{
        setReviewerId(user?.id);
        setReviewerName(user?.firstName + ' ' + user?.lastName);
    };
    const handleReporterChange = (user)=>{
        setReporterId(user?.id);
        setReporterName(user?.firstName + ' ' + user?.lastName);
    };
    const handlePriorityChange = (e)=>{
        setPriority(e.key);
    };
    const onSubmit = async ()=>{
        const errand = {
            comment: comment,
            reviewerComment: reviewerComment,
            followUpComment: date,
            reporterComment: ctx.errand.reporterComment,
            priority: priority,
            reporterId: reporterId,
            reporterName: reporterName,
            reviewerId: reviewerId,
            reviewerName: reviewerName,
            //internalInformation: getInternalInfo(),
            errandTags: ctx.errand.errandTags,
            version: ctx.errand.version
        };
        try {
            await apiRequest(`/Errands/${ctx.errand.id}`, {
                method: 'PUT',
                json: errand
            });
            ctx.reload();
            const inca = incaAccessor();
            inca.overview.refreshOverviewBoxes();
            onSuccess();
        } catch (e) {
            setSaveError(e.message);
        }
    };
    return /*#__PURE__*/ _jsxs(Modal, {
        show: true,
        onHide: onCancel,
        backdrop: "static",
        bsSize: "xl",
        animation: false,
        children: [
            /*#__PURE__*/ _jsx(Modal.Header, {
                closeButton: true,
                children: /*#__PURE__*/ _jsx(Modal.Title, {
                    children: /*#__PURE__*/ _jsx("strong", {
                        children: "Ärendeuppgifter"
                    })
                })
            }),
            /*#__PURE__*/ _jsxs(Modal.Body, {
                children: [
                    /*#__PURE__*/ _jsxs(FormGroup, {
                        componentClass: Row,
                        children: [
                            /*#__PURE__*/ _jsx(ControlLabel, {
                                column: true,
                                sm: 2,
                                children: "Kommentar"
                            }),
                            /*#__PURE__*/ _jsx(Col, {
                                sm: 10,
                                children: /*#__PURE__*/ _jsx(FormControl, {
                                    componentClass: "textarea",
                                    value: comment,
                                    onChange: (e)=>setComment(e.target.value)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(VanillaQuestion, {
                        labelClassName: "col-2",
                        wrapperClassName: "col-10",
                        value: date,
                        regvarMetadata: fakeRegvarMetadata,
                        onValueChange: handleDateChange,
                        required: true
                    }),
                    /*#__PURE__*/ _jsxs(ReviewerSection, {
                        children: [
                            /*#__PURE__*/ _jsxs(FormGroup, {
                                componentClass: Row,
                                children: [
                                    /*#__PURE__*/ _jsx(ControlLabel, {
                                        column: true,
                                        sm: 2,
                                        children: "Notering för granskare"
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        sm: 10,
                                        children: /*#__PURE__*/ _jsx(FormControl, {
                                            componentClass: "textarea",
                                            value: reviewerComment,
                                            onChange: (e)=>setReviewerComment(e.target.value)
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(FormGroup, {
                                componentClass: Row,
                                children: [
                                    /*#__PURE__*/ _jsx(ControlLabel, {
                                        column: true,
                                        sm: 2,
                                        children: "Ansvarig monitor"
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        sm: 10,
                                        children: /*#__PURE__*/ _jsx(Select, {
                                            options: ctx.reviewers,
                                            value: ctx.reviewers?.find((x)=>x.id === reviewerId),
                                            getOptionValue: (x)=>x.id?.toString(),
                                            getOptionLabel: (x)=>x.firstName + ' ' + x.lastName,
                                            placeholder: "--Välj--",
                                            onChange: (e)=>handleReviewerChange(e)
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(FormGroup, {
                                componentClass: Row,
                                children: [
                                    /*#__PURE__*/ _jsx(ControlLabel, {
                                        column: true,
                                        sm: 2,
                                        children: "Prioritet"
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        sm: 10,
                                        children: /*#__PURE__*/ _jsx(Select, {
                                            options: priorities,
                                            value: priorities.find((x)=>x.key === priority),
                                            getOptionValue: (x)=>x.key,
                                            getOptionLabel: (x)=>x.name,
                                            placeholder: "--Välj--",
                                            onChange: (e)=>handlePriorityChange(e)
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(ReporterSection, {
                        children: /*#__PURE__*/ _jsxs(FormGroup, {
                            componentClass: Row,
                            children: [
                                /*#__PURE__*/ _jsx(ControlLabel, {
                                    column: true,
                                    sm: 2,
                                    children: "Ansvarig inrapportör"
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    sm: 10,
                                    children: /*#__PURE__*/ _jsx(Select, {
                                        options: ctx.reporters,
                                        value: ctx.reporters?.find((x)=>x.id === reporterId),
                                        getOptionValue: (x)=>x.id.toString(),
                                        getOptionLabel: (x)=>x.firstName + ' ' + x.lastName,
                                        placeholder: "--Välj--",
                                        onChange: (e)=>handleReporterChange(e)
                                    })
                                })
                            ]
                        })
                    }),
                    saveError && /*#__PURE__*/ _jsx(Alert, {
                        bsStyle: "danger",
                        className: "mt-3",
                        children: saveError
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Modal.Footer, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        icon: faTimes,
                        onClick: onCancel,
                        bsStyle: "default-2",
                        children: "Avbryt"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        icon: faSave,
                        bsStyle: "primary",
                        className: "mr-2",
                        onClick: onSubmit,
                        children: "Spara"
                    })
                ]
            })
        ]
    });
};
